module.exports = __webpack_public_path__ + "static/img/minip3.5f5f5c76.png";